<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import DynamicFilterBase from '@js/components/filter/dynamic-filter-base';

export default {
    extends: DynamicFilterBase,

    data() {
        let that = this;

        return {
            externalRemotes: {
                outlet(query) {
                    return that.outletRemote(query);
                },
            },
        };
    },

    computed: {
        ...mapState('override_pricebook', ['filters', 'searchMeta']),

        loading() {
            return this.onLoading('get-override-pricebook-meta');
        },
    },

    created() {
        this.getSearchOverridePricebook();
        this.getOutletListIfNecessary();
    },

    methods: {
        ...mapActions('override_pricebook', ['getSearchOverridePricebook']),
        ...mapMutations('override_pricebook', ['setFilters']),
        ...mapActions('outlet', ['getOutletListIfNecessary']),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/override_pricebook/override-pricebook-filter.vue